export default __webpack_public_path__ + "static/media/shopify_glyph.8e5ec92d.png";